import React from 'react';
import PropTypes from 'prop-types';
import { CloseSmallIcon } from 'DesignSystem/Icons';

const ModalCloseButton = ({
  isCloseButtonVisible,
  onClick,
}) => {
  if (!isCloseButtonVisible) {
    return null;
  }

  return (
    <div className="ds-modal-close-btn-container">
      <CloseSmallIcon
        className="ds-modal-close-btn cursor-pointer"
        onClick={onClick}
      />
    </div>
  );
};

ModalCloseButton.defaultProps = {
  isCloseButtonVisible: true,
  onClick: () => {},
};

ModalCloseButton.propTypes = {
  isCloseButtonVisible: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ModalCloseButton;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/FormSwiftModal/ModalCloseButton.jsx